import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import PropTypes from "prop-types";
import Button from "components/CustomButtons/Button.js";
import Spinner from "components/Spinner";
import ComboBox from "components/ComboBox";
import { Alert, AlertTitle } from "@material-ui/lab";
import { isEmptyObject } from "helpers/utils";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(2),
      width: 200,
    },
  },
  newUserButton: {
    display: "flex",
    justifyContent: "center",
  },
}));

export default function DeviceEditor({
  loading,
  onEdit,
  formData,
  status,
  deviceTypesKv,
  farmsKv,
}) {
  const classes = useStyles();
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  console.log("xxxx data", JSON.stringify(data));
  useEffect(() => {
    setData(formData);
    setErrors({});
    return () => setData({});
  }, [formData]);

  const handleDeviceTypeSelection = (e) => {
    if (!isEmptyObject(errors)) {
      setErrors({});
    }
    let oldData = { ...data };
    oldData["deviceTypeId"] = e.target.value;
    setData(oldData);
  };
  const handleFarmSelection = (e) => {
    if (!isEmptyObject(errors)) {
      setErrors({});
    }
    let oldData = { ...data };
    oldData["farmId"] = e.target.value;
    setData(oldData);
  };
  

  const handleClick = () => {
    let errorList = {};
    // if (!data.villageId) errorList.villageId = "field cannot be empty";
    // if (!data.ownerId) errorList.ownerId = "field cannot be empty";
    // if (!data.cropId) errorList.cropId = "field cannot be empty";
    // if (!data.name) errorList.name = "field cannot be empty";
    // if (!data.coordinates) errorList.coordinates = "field cannot be empty";
    if (isEmptyObject(errorList)) {
      let edited = { ...data };
      let changes = Object.fromEntries(
        Object.entries(edited).filter(
          ([k, v]) => k === "id" || v !== formData[k]
        )
      );
      onEdit(changes);
    } else setErrors(errorList);
  };
  const checkError = (field) => {
    return errors[field] !== undefined;
  };
  function handleChange(event, name) {
    let oldData = { ...data };
    oldData[name] = event.target.value;
    setData(oldData);
  }
  return (
    <form className={classes.root} noValidate autoComplete="off">
      <div>
        <ComboBox
          error={errors["deviceTypeId"]}
          value={data["deviceTypeId"]}
          label={"Device Type"}
          onSelect={handleDeviceTypeSelection}
          kvOptions={deviceTypesKv}
        />
        <ComboBox
          error={errors["farmId"]}
          value={data["farmId"]}
          label={"Farm"}
          onSelect={handleFarmSelection}
          kvOptions={farmsKv}
        />
      </div>
      <div>
        <TextField
          error={checkError("msisdn")}
          label="Msisdn"
          id="msisdn"
          value={data.msisdn}
          onChange={(e) => handleChange(e, "msisdn")}
          variant="outlined"
          helperText={errors.msisdn}
          size="small"
        />
        <TextField
          error={checkError("number")}
          label="Number"
          id="number"
          value={data.number}
          onChange={(e) => handleChange(e, "number")}
          variant="outlined"
          helperText={errors.number}
          size="small"
        />
      </div>
      {loading && <Spinner />}
      {!loading && status === "FAILED" && (
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          Update failed!
        </Alert>
      )}
      {!loading && status === "SUCCESS" && (
        <Alert severity="success">
          <AlertTitle>Success</AlertTitle>
          Update successful!
        </Alert>
      )}
      <div className={classes.newUserButton}>
        <Button
          color="primary"
          round
          disabled={loading}
          onClick={() => handleClick(data)}
        >
          Update
        </Button>
      </div>
    </form>
  );
}
DeviceEditor.propTypes = {
  loading: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  formData: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
  deviceTypesKv: PropTypes.array.isRequired,
  farmsKv: PropTypes.array.isRequired
};
